<template>
  <div class="vgt-global-search vgt-clearfix" style="width: 100%">
    <div class="vgt-global-search__input vgt-pull-right">
      <span
        class="input__icon ts-cursor-pointer"
        @click.prevent="onEnter"
      >
        <div class="magnifying-glass"></div>
      </span>

      <input
        v-model="model"
        type="text"
        ref="search_substitute_code"
        @keypress.enter="onEnter"
        placeholder="Search substitute code"
        class="vgt-input vgt-pull-right"
      />

      <span
        class="input__icon ts-cursor-pointer"
        @click.prevent="onEnter"
      >
        <div class="magnifying-glass"></div>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      model: this.value
    }
  },
  watch: {
    value (val) {
      this.model = val
    },
    model (val) {
      this.$emit('input', val)
    }
  },
  mounted () {
    this.$refs.search_substitute_code.focus()
  },
  methods: {
    onEnter () {
      this.$emit('onEnter', this.model)
    }
  }
}
</script>
